(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('OpenInvoiceModalController', OpenInvoiceModalController);

    OpenInvoiceModalController.$inject = ['$uibModalInstance', '$timeout','InvoicesService', 'invoice', 'getInvoices', 'CurrencyService', 'InvoicePaymentFeeService','toastr'];

    function OpenInvoiceModalController($uibModalInstance, $timeout, InvoicesService, invoice, getInvoices, CurrencyService, InvoicePaymentFeeService, toastr) {
        var vm = this;
        vm.invoice               = invoice;
        vm.getInvoices           = getInvoices;
        vm.amountToBePaid        = 0;
        vm.amountReceived        = '';
        vm.amountReceivedTemp    = '';
        vm.exchangeRate          = '';
        vm.exchangeRateTemp      = '';
        vm.paymentDate           = '';
        vm.paymentMethodSelected = '';
        vm.paymentMethodList     = '';
        vm.simulatedCalculation  = 0;

        vm.paymentCurrencySelected   = '';
        vm.paymentCurrencyList       = '';
        vm.bankCreditAccountSelected = '';
        vm.statusInvoice             = '';

        vm.historic                 = '';
        vm.writeOff                 = false;
        vm.categorySelected         = [];
        vm.categoryList             = '';
        vm.invoiceItemsList         = [];
        vm.invoicesAccountSelected  = [];
        vm.invoicesAccountList      = '';
        vm.invoiceItems             = {};
        vm.bankCreditAccountSelected = [];
        vm.bankCreditAccountList     = '';
        vm.datePickerOptions    = {
            format: "D-MMM-YY",
            singleDatePicker: true,
            showDropdowns: true,
            maxDate: new Date()
        };
        vm.exchangeRate              = {};
        vm.invoicesFee               = [];
        vm.feeAmount                 = '';
        vm.feeCategorySelected       = {id:11, name:'Overhead', parent_id:null};
        vm.feeAccountSelected        = {id:35, name:'Wire Transfer Fee income', sub_type:'ServiceFeeIncome',classification:'Revenue',  parent_id:null};
        vm.invoicesPaymentsFees      = [];
        vm.getCostCenterCategory    = getCostCenterCategory;
        vm.getInvoicesAccount       = getInvoicesAccount;
        vm.getInvoicesBankAccount   = getInvoicesBankAccount;
        vm.getInvoiceItemsList      = getInvoiceItemsList;
        vm.getInvoicePaymentHistory = getInvoicePaymentHistory;
        vm.getPaymentCurrencies     = getPaymentCurrencies;
        vm.getBanks                 = getBanks;
        vm.getPaymentsMethods       = getPaymentsMethods;
        vm.getInvoicePaymentHistory = getInvoicePaymentHistory;
        vm.save                     = save;
        vm.cancel                   = cancel;
        vm.addInvoiceItems          = addInvoiceItems;
        vm.getExchangeRate          = getExchangeRate;
        vm.getFees                  = getFees;
        vm.addFees                  = addFees;
        vm.removeFee                = removeFee;
        vm.fillCostCenterInvoiceItems = fillCostCenterInvoiceItems;

        activate();

        function activate() {
            vm.getPaymentCurrencies();
            vm.getBanks();
            vm.getCostCenterCategory();
            vm.getInvoicesAccount();
            vm.getInvoicesBankAccount();
            vm.getPaymentsMethods();
            vm.getInvoiceItemsList();
            vm.getInvoicePaymentHistory();
        }

        function getInvoiceItemsList() {
            InvoicesService.getInvoicePaymentItems(vm.invoice.id).then(function(response) {
                vm.invoiceItemsList = response.data;
                $timeout(function(){
                    angular.forEach(vm.invoiceItemsList, function(invoice){
                        if(typeof vm.categorySelected[invoice.id] == 'undefined') {
                            vm.categorySelected[invoice.id] = [];
                        }
                        if(typeof vm.invoicesAccountSelected[invoice.id] == 'undefined') {
                            vm.invoicesAccountSelected[invoice.id] = [];
                        }
                        angular.forEach(vm.categoryList, function (value) {
                            this[value.id] = value;
                        },vm.categorySelected[invoice.id]);
                        angular.forEach(vm.invoicesAccountList, function (value) {
                            this[value.id] = value;
                        },vm.invoicesAccountSelected[invoice.id]);
                    });
                },0);
            }).catch(function(err) {
            });
        }

        function getPaymentCurrencies() {
            InvoicesService.getPaymentCurrencies().then(function(response) {
                vm.paymentCurrencyList = response.data;
            }).catch(function(err) {
            });
        }

        function getCostCenterCategory() {
            InvoicesService.getInvoicesCostCenterCategory().then(function(response) {
                vm.categoryList = response.data;
            }).catch(function(err) {
            });
        }

        function getInvoicesAccount() {
            InvoicesService.getInvoicesAccount().then(function(response) {
                    vm.invoicesAccountList = response.data;
            }).catch(function(err) {
            });
        }

        function getInvoicesBankAccount() {
            InvoicesService.getInvoicesBankAccount().then(function(response) {
                $timeout(function(){
                    vm.bankCreditAccountList = response.data;
                },0);
            }).catch(function(err) {
            });
        }

        function getInvoicePaymentHistory() {
            vm.amountToBePaid = vm.invoice.total_calculated;
            if(vm.invoice.id) {
                InvoicesService.getInvoicePaymentHistory(vm.invoice.id).then(function (response) {
                    vm.invoicesPaymentsList = response.data;
                    if(response.data[0]) {
                        vm.amountToBePaid = vm.invoice.total_calculated - response.data[0].amount_to_be_paid;
                    }
                }).catch(function (err) {
                });
            }
        }

        function getBanks() {
            InvoicesService.getBanks().then(function (response) {
                vm.bankCreditAccountList = response.data;
            }).catch(function (err) {
            });
        }

        function getPaymentsMethods() {
            InvoicesService.getPaymentsMethods().then(function (response) {
                vm.paymentMethodList = response.data;
            }).catch(function (err) {
            });
        }

        function save() {
            var query = {};

            if(vm.amountToBePaid !== '') {
                query['amount_to_be_paid'] = vm.amountToBePaid;
            }
            if(vm.amountReceived !== '') {
                query['amount_received'] = vm.amountReceived;
            }
            if(vm.exchangeRate !== '') {
                query['exchange_rate'] = vm.exchangeRate;
            }
            if(vm.paymentDate !== '') {
                query['pay_day'] = vm.paymentDate.format('YYYY-MM-DD');
            }
            if(vm.paymentMethodSelected !== '') {
                query['payment_method_id'] = vm.paymentMethodSelected.id;
            }
            if(vm.bankCreditAccountSelected !== '') {
                query['bank_id'] = vm.bankCreditAccountSelected.id;
            }
            if(vm.invoiceItems !== '') {
                query['invoice_items'] = vm.invoiceItems;
            }
            if(vm.writeOff !== '') {
                query['write_off'] = vm.writeOff;
            }
            if(vm.historic !== '') {
                query['historic'] = vm.historic;
            }
            
            /* FEES */
            if(vm.invoicesPaymentsFees !== []) {
                query['fee'] =  vm.invoicesFee;
            }
            query['status']             = vm.invoice.status;
            query['creation_date']      = vm.invoice.created_at;
            query['invoice_currency']   = vm.invoice.currency;
            if(vm.paymentCurrencySelected) {
                query['payment_currency']   = vm.paymentCurrencySelected.code;
            }
            query['invoice_id']      = vm.invoice.id;
            query['total_rate']      = vm.invoice.total_calculated;
            InvoicesService.saveInvoicePayment(query).then(function(response) {
                vm.invoicesPaymentsList = response.data.data;
                toastr.success('Successfully saved!');
                vm.getInvoices();
                $uibModalInstance.close();
                //vm.getInvoicePaymentHistory();
                // vm.totalItems = response.data.total;
                // vm.to = response.data.to;
                // vm.itemsPerPage = response.data.per_page;
                // vm.setPage(response.data.current_page);
            }).catch(function(err) {
            });
        }

        function addInvoiceItems(itemSelected, obj, type) {
            
            if(typeof vm.invoiceItems[obj.id] == 'undefined') {
                vm.invoiceItems[obj.id] = {};
            }
            vm.invoiceItems[obj.id].id = obj.id;
            if(type === 'cost_center') {
                vm.invoiceItems[obj.id].cost_center_id = itemSelected.id;
                vm.feeCategorySelected[itemSelected.cost_center_id] = itemSelected;
            } else {
                vm.invoiceItems[obj.id].account_id = itemSelected.id;
                vm.feeCategorySelected[itemSelected.account_id] = itemSelected;
            }
            vm.invoiceItems[obj.id].item_id = itemSelected.item_id;
            vm.invoiceItems[obj.id].type = itemSelected.type;
        }

        function cancel() {
            $uibModalInstance.close();
        }

        function getExchangeRate() {
            var query = {};
            query['to']   = vm.invoice.currency;
            query['from'] = vm.paymentCurrencySelected.code;
            query['date'] = vm.paymentDate.format('YYYY-MM-DD');
            CurrencyService.getExchangeRate(query).then(function(response) {
                vm.exchangeRate = response.data;
                vm.amountReceivedTemp = vm.amountReceived;
                vm.exchangeRateTemp = vm.exchangeRate;
                vm.simulatedCalculation = vm.amountToBePaid - (vm.exchangeRateTemp * vm.amountReceivedTemp);
            }).catch(function(err) {
            });
        }

        function getFees(invoicePaymentId) {
            if (vm.invoicesPaymentsFees[invoicePaymentId]) {
                delete vm.invoicesPaymentsFees[invoicePaymentId];
                return false;
            }

            var query = {};
            query['invoice_payment_id'] = invoicePaymentId;
            InvoicePaymentFeeService.getFees(query).then(function(response) {
                vm.invoicesPaymentsFees[invoicePaymentId] = response.data;
            }).catch(function(err) {
            });
        }

        function addFees() {
            var query = {
                        'amount': vm.feeAmount,
                        'invoice_payment_id': vm.invoice.id,
                        'cost_center': vm.feeCategorySelected,
                        'fin_cost_center_id': vm.feeCategorySelected.id,
                        'account': vm.feeAccountSelected,
                        'fin_account_id': vm.feeAccountSelected.id,
                        'currency_code_received': vm.paymentCurrencySelected.code,
                        'currency_code_invoice': vm.invoice.currency,
                        'exchange_rate': vm.exchangeRateTemp
                        };                      
            vm.invoicesFee.push(query);
            vm.feeAmount = '';
        }

        function removeFee(item) {
            vm.invoicesFee.splice(vm.invoicesFee.indexOf(item), 1);
        }

        function fillCostCenterInvoiceItems(item) {
            item = vm.categoryList.filter(function(currentItem){
                return currentItem.id === item.id;
            })
        }
    }

})();